/** Fragment target for skip navigation; must match `<main id={...}>`. */
export const MAIN_CONTENT_ID = 'main-content';
